
document.addEventListener("DOMContentLoaded", function() {

  const blocks = document.querySelectorAll('.feature-block');
  const modal = document.getElementById('featureModalSlider');
  const closeBtn = modal.querySelector('.feature-modal-close');

  const $slider = $('.feature-modal-slider-track');

  // INIT SLICK
  if (!$slider.hasClass('slick-initialized')) {
    $slider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,          // ✅ ARROWS ON
      dots: true,
      swipe: true,           // ✅ TOUCH SWIPE
      draggable: true,       // ✅ MOUSE DRAG
      touchMove: true,       // ✅ MOBILE SWIPE
      adaptiveHeight: true,
      speed: 400,
      prevArrow: `<button type="button" class="popup-slick-arrow slider-button slider-button--prev popup-slick-prev" name="previous" aria-label="Slide left">
        <span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="#006778" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg></span></button>`,
      nextArrow: `<button type="button" class="popup-slick-arrow slider-button slider-button--next popup-slick-next" name="next" aria-label="Slide right">
        <span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="#006778" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg>
</span>
      </button>`
    });
  }

  // OPEN MODAL
  blocks.forEach(block => {
    block.addEventListener('click', () => {
      const index = parseInt(block.getAttribute('data-index'));
      modal.classList.add('active');

      // Go to clicked slide
      $slider.slick('slickGoTo', index, true);
    });
  });

  // CLOSE
  closeBtn.addEventListener('click', () => {
    modal.classList.remove('active');
  });

  modal.addEventListener('click', (e) => {
    if(e.target === modal){
      modal.classList.remove('active');
    }
  });

});
